module.exports = __webpack_public_path__ + "static/media/linkedinStatic.3489799e.svg";